export default "__VITE_ASSET__BJelOBhh__"